import script from "./BlogPage.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogPage.vue?vue&type=script&setup=true&lang=js"

import "./BlogPage.vue?vue&type=style&index=0&id=2f880bc6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f880bc6"]])

export default __exports__